import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDisplayTheme } from 'hooks/useUiState'
import { Theme } from 'features/ui/types'
import { AutomationId } from 'utils/automationUtil'
import { TopAuthorsTypeStrings } from 'components/insightContent/enum/TopAuthorsType'
import openHelpPage from 'utils/helpLinkUtil'
import LinkButton from 'components/share/LinkButton'
// @ts-ignore
import { Tooltip, QuestionMarkOutlined } from '@netbasequid/core'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { getHeaderText } from '../utils'
import { StyledBody, StyledHeader, StyledLeft, StyledRight, StyledIconBox } from './index.css'

const TableFrame = ({ postType, children }: { postType: TopAuthorsTypeStrings; children: any }) => {
  const theme = useDisplayTheme() as Theme
  const { t } = useTranslation()

  return (
    <>
      <StyledHeader mode={theme}>
        <StyledLeft data-testid={AutomationId.insightModal.insightContent.topAuthor.leftHeader}>
          {getHeaderText(postType)}
        </StyledLeft>
        <StyledRight data-testid={AutomationId.insightModal.insightContent.topAuthor.rightHeader}>
          {t('followersVisitors')}
          &nbsp;
          <LinkButton onClick={() => openHelpPage(8292283)}>
            <StyledIconBox mode={theme}>
              <Tooltip mode={theme} content={<>{t('popularLinksInsightModalTooltip')}</>}>
                <QuestionMarkOutlined color={sys[theme].text.placeholder} />
              </Tooltip>
            </StyledIconBox>
          </LinkButton>
        </StyledRight>
      </StyledHeader>
      <StyledBody>{children}</StyledBody>
    </>
  )
}

export default TableFrame
